import React from 'react'

function CreateReceiptPayments() {
  return (
    <div>CreateReceiptPayments</div>
  )
}

export default CreateReceiptPayments